<template lang="pug">
	.track-events-settings
		button.btn.btn-sm.btn-outline-secondary.expand-button(@click="toggle()")
			i.fa(:class="{'fa-angle-double-down': !expanded, 'fa-angle-double-up': expanded}")
			span {{expanded ? 'Collapse events list' : 'Expand events list'}}
			i.fa(:class="{'fa-angle-double-down': !expanded, 'fa-angle-double-up': expanded}")
		.events-list(:class="{expanded: expanded}" v-pseudo-modal-name="'track-events-settings-events-list'")
			.event-item(v-for="event in events" :class="{expanded: expandedEvent === event.name, disabled: isEventDisabled(event.name)}")
				.event-main-data(:class="{mandatory: event.mandatory, custom: event.custom}")
					.titles(@click="expandEventDetails(event.name)")
						.event-title-line
							.event-title(:ref="event.name + '-event-title-el'" :contentEditable="expandedEvent === event.name && titleEditable" @blur="stopEditName()") {{(settingValue && settingValue[event.name] && settingValue[event.name].name) ? settingValue[event.name].name : event.name}}
							i.fa.fa-pencil.edit-button(v-show="expandedEvent === event.name && !titleEditable" @click="startEditName()" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Edit event title'}")
							i.fa.fa-refresh.revert-button(v-show="settingValue && settingValue[event.name] && settingValue[event.name].name && expandedEvent === event.name && !titleEditable" @click="revertName()" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Return original event title'}")
						.event-description-line
							.event-description.text-muted(:ref="event.name + '-event-description-el'" :contentEditable="expandedEvent === event.name && descriptionEditable" @blur="stopEditDescription()") {{(settingValue && settingValue[event.name] && settingValue[event.name].description) ? settingValue[event.name].description : event.description}}
							i.fa.fa-pencil.edit-button(v-show="expandedEvent === event.name && !descriptionEditable" @click="startEditDescription()" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Edit event description'}")
							i.fa.fa-refresh.revert-button(v-show="settingValue && settingValue[event.name] && settingValue[event.name].description && expandedEvent === event.name && !descriptionEditable" @click="revertDescription()" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Return original event description'}")
						.event-settings-line(v-show="expandedEvent === event.name")
							.setting-wrapper
								.form-check
									input.form-check-input(type="checkbox" :checked="settingValue && settingValue[event.name] ? settingValue[event.name].trackFirstOnly : event.trackFirstOnly" v-on:change="editEventTrackFirstOnly(event, $event.target.checked)")
									label.form-check-label Track first event only
					.fast-controls
						.fast-control.disable-control(@click="toggleEventDisabled(event.name)")
							i.fa.fa-remove(v-show="!(isEventDisabled(event.name))" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Disable this event tracking for all tracking providers'}")
							i.fa.fa-refresh(v-show="isEventDisabled(event.name)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Enable this event tracking for all tracking providers'}")
				.event-details(v-show="expandedEvent === event.name && !(isEventDisabled(event.name))")

</template>

<script>

	import Screen 				from './../../../mixins/screen';

	import { Creative } 			from './../../../services/Creative';
	import { Settings } 		from './../../../services/Settings';
	import { Version } 			from './../../../services/Version';

	export default {
		name: "TrackingEventsSettings",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Version Switched", "Selected Version Fully Loaded"],
			events: {
				"Pseudo Modal Process Hide": function(names) {

					if (!this.expandedEvent) return;
					if (!_.includes(names, 'track-events-settings-events-list')) this.collapseEventDetails();

				}
			}
		},
		props: ['setting'],
		data() {

			this.Creative = Creative;
			this.Settings = Settings;

			this.events = [];
			this.settingValue = {};

			return {
				showed: true,
				expanded: false,
				expandedEvent: null,
				titleEditable: false,
				descriptionEditable: false
			}

		},
		mounted() {

			//Сообщаем компоненту что он должен обновляться при изменении указанных настроек активной версии креатива
			this.addUpdateEvent([`Selected Version Setting Changed:track-events-settings`, `Selected Version Setting Changed:track-events`]);

		},
		methods: {
			collectData() {

				if (!Version.SelectedVersion || !this.setting || !Settings.isSettingExist(this.setting.codename)) return console.log('TrackingEventsSettings collectData FAILED', this.setting?.['codename'], Version.SelectedVersion?.id, this.setting?.['version_id']);

				this.events = Settings.getSettingValue('track-events') || [];
				this.settingValue = Settings.getSettingValue(this.setting.codename) || [];

			},
			toggle() {

				this.expanded = !this.expanded;

			},
			expandEventDetails(eventName) {

				if (this.isEventDisabled(eventName)) return;

				if (this.expandedEvent !== eventName) {

					this.titleEditable = false;
					this.descriptionEditable = false;

				}

				this.expandedEvent = eventName;

			},
			collapseEventDetails() {

				this.expandedEvent = null;
				this.titleEditable = false;
				this.descriptionEditable = false;

			},

			isEventDisabled(eventName) {
				return !!(this.settingValue && this.settingValue[eventName] && this.settingValue[eventName].hasOwnProperty('disabled')) ? !!this.settingValue[eventName].disabled : this.events.find(e => e.name === eventName).disabled;
			},

			startEditName() {

				this.titleEditable = true;

				setTimeout(() => {

					this.$refs[this.expandedEvent + '-event-title-el'][0].focus();
					this.setEndOfContenteditable(this.$refs[this.expandedEvent + '-event-title-el'][0]);

				}, 100)

			},
			stopEditName() {

				let newTitle = this.$refs[this.expandedEvent + '-event-title-el'][0].innerText;

				if (newTitle !== this.expandedEvent && newTitle !== this.settingValue?.[this.expandedEvent]?.name) {

					if (!this.settingValue) this.settingValue = {};
					if (!this.settingValue[this.expandedEvent]) this.settingValue[this.expandedEvent] = {};
					this.settingValue[this.expandedEvent].name = this.$refs[this.expandedEvent + '-event-title-el'][0].innerText;

					this.delaySave();

					this.$forceUpdate();

				}

				this.titleEditable = false;

			},
			startEditDescription() {

				this.descriptionEditable = true;

				setTimeout(() => {

					this.$refs[this.expandedEvent + '-event-description-el'][0].focus();
					this.setEndOfContenteditable(this.$refs[this.expandedEvent + '-event-description-el'][0]);

				}, 100)

			},
			stopEditDescription() {

				let newDescription = this.$refs[this.expandedEvent + '-event-description-el'][0].innerText;

				if (newDescription !== this.expandedEvent && newDescription !== this.settingValue?.[this.expandedEvent]?.description) {

					if (!this.settingValue) this.settingValue = {};
					if (!this.settingValue[this.expandedEvent]) this.settingValue[this.expandedEvent] = {};
					this.settingValue[this.expandedEvent].description = this.$refs[this.expandedEvent + '-event-description-el'][0].innerText;

					this.delaySave();

					this.$forceUpdate();

				}

				this.descriptionEditable = false;

			},
			setEndOfContenteditable(contentEditableElement) {

				if (document.createRange) {

					let range = document.createRange();//Create a range (a range is a like the selection but invisible)
					range.selectNodeContents(contentEditableElement);//Select the entire contents of the element with the range
					range.collapse(false);//collapse the range to the end point. false means collapse to end rather than the start

					let selection = window.getSelection();//get the selection object (allows you to change selection)
					selection.removeAllRanges();//remove any selections already made
					selection.addRange(range);//make the range you have just created the visible selection

				}

			},
			revertName() {

				if (this.settingValue?.[this.expandedEvent]?.name) {

					delete this.settingValue[this.expandedEvent].name;

					this.delaySave();

					this.$forceUpdate();

				}

			},
			revertDescription() {

				if (this.settingValue?.[this.expandedEvent]?.description) {

					delete this.settingValue[this.expandedEvent].description;

					this.delaySave();

					this.$forceUpdate();

				}

			},
			toggleEventDisabled(eventName) {

				if (!this.settingValue[eventName]) this.settingValue[eventName] = {};

				this.settingValue[eventName].disabled = !this.isEventDisabled(eventName);

				this.delaySave();

				this.$forceUpdate();

			},

			editEventTrackFirstOnly(event, value) {

				if (!event || !event.name) return;

				if (!this.settingValue[event.name]) this.settingValue[event.name] = {};

				this.settingValue[event.name].trackFirstOnly = value;

				this.delaySave();

				this.$forceUpdate();
			},

			delaySave() {

				clearTimeout(this.saveTimeout);
				this.saveTimeout = setTimeout(() => {

					Server.sendToSocket({
						UpdateCreativeVersionSetting: {
							versionId: Version.SelectedVersion.id,
							settingCodename: this.setting.codename,
							value: this.settingValue
						}
					});

					console.log(this.settingValue);

				}, 200);

			}
		}
	}
</script>

<style lang="sass">

	.track-events-settings
		display: flex
		justify-content: space-between
		user-select: none
		position: relative
		flex-direction: column
		max-width: 338px

		.expand-button
			border: 1px solid #23282c
			background-color: #343b41
			margin-top: 5px

			span
				margin: 0 7px

			&:focus
				outline: none
				border-color: inherit
				-webkit-box-shadow: none
				box-shadow: none
				border-radius: 3px

		.events-list
			position: relative
			margin-top: 5px
			border: 1px solid #23282c
			border-radius: 5px
			background-color: #343b41
			font-size: 12px
			overflow: hidden
			transition: height 1s
			display: none

			.event-item
				display: flex
				flex-direction: column
				position: relative
				user-select: none
				transition: background-color 0.2s

				&:not(:first-child)
					border-top: 1px solid rgba(0, 0, 0, 0.1)

				&:hover
					background-color: #2f363c

				.event-main-data
					display: flex
					flex-direction: row
					justify-content: space-between
					padding: 0 5px 0px 5px

					.titles
						display: flex
						flex-direction: column
						cursor: pointer
						flex-grow: 1

						.event-title-line
							display: flex
							flex-direction: row

							.event-title
								font-size: 13px

								&:focus
									outline: none
									border-color: inherit
									-webkit-box-shadow: none
									box-shadow: none
									border-bottom: 1px solid rgba(255, 255, 255, 0.1)

							i
								display: flex
								justify-content: center
								align-items: center
								padding: 0 5px
								opacity: 0.1

								&:hover
									color: var(--primary)
									opacity: 1

						.event-description-line
							display: flex
							flex-direction: row

							.event-description
								font-size: 12px

								&:focus
									outline: none
									border-color: inherit
									-webkit-box-shadow: none
									box-shadow: none
									border-bottom: 1px solid rgba(255, 255, 255, 0.1)

							i
								display: flex
								justify-content: center
								align-items: center
								padding: 0 5px
								opacity: 0.1

								&:hover
									color: var(--primary)
									opacity: 1

						.event-settings-line

							>.setting-wrapper
								display: flex
								flex-direction: row
								justify-content: left
								padding: 2px 0
								border-top: 1px solid #212529

								.form-check
									padding-left: unset
									font-size: unset
									display: flex
									color: #73818f
									gap: 5px

									>.form-check-input
										position: unset
										margin-top: unset
										margin-left: unset

					.fast-controls
						width: 50px
						min-width: 50px
						display: flex
						justify-content: right
						align-items: center

						.fast-control
							font-size: 15px
							cursor: pointer
							height: 30px
							width: 30px
							display: flex
							justify-content: center
							align-items: center

							&:hover
								color: var(--primary)

				.event-main-data.custom

					.event-title
						color: var(--info)

				.event-details
					border-top: 1px solid rgba(0, 0, 0, 0.1)
					padding: 0 5px 0px 5px

			.event-item.expanded
				background-color: rgba(0, 0, 0, 0.2)

				.event-main-data

					.event-title
						font-size: 13px

					.event-description
						font-size: 12px

			.event-item.disabled

				.event-main-data

					.event-title
						text-decoration: line-through
						color: #73818f
						opacity: 0.2

					.event-description
						text-decoration: line-through
						opacity: 0.2

		.events-list.expanded
			display: block
</style>
